import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@quake/shared-ui/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        success:
          "border-transparent bg-emerald-700 text-white shadow hover:bg-emerald-800 dark:bg-emerald-400 dark:text-emerald-950 dark:hover:bg-emerald-300",
        warning:
          "border-transparent bg-amber-100 text-amber-800 shadow hover:bg-amber-200 dark:bg-amber-400/15 dark:text-amber-300 dark:hover:bg-amber-400/20",
        default: "border-transparent bg-primary text-primary-foreground shadow hover:bg-primary/80",
        secondary: "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-red-700 text-white shadow hover:bg-red-800 dark:bg-destructive dark:text-destructive-foreground dark:hover:bg-destructive/80",
        outline: "text-foreground",
      },
      radius: {
        default: "rounded-md",
        full: "rounded-full",
      },
    },
    defaultVariants: {
      variant: "default",
      radius: "default",
    },
  },
);

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, radius, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant, radius }), className)} {...props} />;
}

export { Badge, badgeVariants };
